<template>
	<MainLayout>
		<div class="container">
			<div class="box">
				<b-tabs no-fade pills card>
					<b-tab title="Canales de Venta" active>
						<div class="mt-3">
							<b-button v-if="$hasPermission('channel.add')" class="float-right" @click="newDestination"
								>Nuevo Canal de venta</b-button
							>
							<h4>Canales de venta</h4>
							<hr />
							<b-form
								@submit="
									evt => {
										evt.preventDefault();
										this.$root.$emit(
											'bv::refresh::table',
											'sales-channels-index-list'
										);
									}
								"
							>
								<div class="row">
									<b-form-group class="col-2" label="Buscar">
										<b-form-input
											v-model="filters.search"
											type="text"
										/>
									</b-form-group>
									<b-form-group class="col-2" label=".">
										<b-button type="submit" variant="primary"
											>Buscar</b-button
										>
									</b-form-group>
								</div>
							</b-form>
							<AjaxTable
								permission-show="channel.show"
								id="sales-channels-index-list"
								:filters="filters"
								:columns="modelColumns"
								resource="sales-channels"
							>
								<template v-slot:cell(actions)="row">
									<div class="text-center">
										<!-- <b-button :href="'/sales-channel-contacts?id='+row.item.id" type="button" size="sm" class="mr-1" variant="info">
												<md-icon icon="contacts" />
											</b-button> -->
										<b-button
											@click="
												event =>
													userView(row.item, row.index, event)
											"
											type="button"
											size="sm"
											class="mr-1"
											variant="info"
										>
											<md-icon icon="edit" />
										</b-button>
										<b-button
											@click="
												event =>
													userDelete(row.item, row.index, event)
											"
											v-if="$hasPermission('channel.delete')"
											type="button"
											size="sm"
											class="mr-1"
											variant="danger"
										>
											<md-icon icon="delete" />
										</b-button>
									</div>
								</template>
							</AjaxTable>
						</div>
					</b-tab>
					<b-tab title="Grupos de Canales">
						<SalesChannelGroups />
					</b-tab>
				</b-tabs>
			</div>
			<hr />
		</div>

		<b-modal
			dialog-class="sx-modal-xl"
			hide-footer
			id="modal-sales-channels-view"
			size="xl"
			:title="modalInfo.modelId > 0 ? 'Edición de canal' : 'Nuevo canal'"
		>
			<Single
				:unableEdit.sync="unableEdit"
				:model-id="modalInfo.modelId"
				@model-id="modalInfo.modelId = $event"
				modal-id="modal-sales-channels-view"
			/>
		</b-modal>
	</MainLayout>
</template>

<script>
import MainLayout from "../layout/MainLayout.vue";
import AjaxTable from "../../helpers/AjaxTable.vue";
import Single from "./Single.vue";
import SalesChannelGroups from "./groups/Index.vue";
import api from "../../../api.js";

export default {
	components: { MainLayout, Single, AjaxTable, SalesChannelGroups },
	data() {
		return {
			unableEdit: false,
			item: {},
			modalInfo: {
				modelId: -1,
				title: "Destino"
			},
			filters: {
				search: ""
			},
			modelColumns: [
				{ key: "id", label: "ID" },
				{ key: "code", label: "Codigo" },
				{ key: "name", label: "Nombre" },
				{ key: "salesChannelGroup", label: "Grupo" },
				{ key: "zonedAreasTitles", label: "Áreas de operación" },
				{ key: "description", label: "Descripción" },
				{ key: "status", label: "Estado" },
				{ key: "actions", label: "Acciones" }
			]
		};
	},
	methods: {
		userView(item, index, event) {
			this.unableEdit = !this.$hasPermission('channel.edit')
			this.modalInfo.modelId = item.id;
			this.$root.$emit(
				"bv::show::modal",
				"modal-sales-channels-view",
				event.target
			);
		},
		newDestination(event) {
			this.unableEdit = false
			this.modalInfo.modelId = -1;
			this.$root.$emit(
				"bv::show::modal",
				"modal-sales-channels-view",
				event.target
			);
		},
		userDelete(item) {
			this.$root.showWarning({
				okAction: (event, setLoading, close) => {
					setLoading(true);
					api(this)
						.delete(`/sales-channels/${item.id}`)
						.then(() => {
							this.$root.showAlert("Registro Eliminado!", {
								variant: "warning"
							});
							this.$root.$emit(
								"bv::refresh::table",
								"sales-channels-index-list"
							);
							this.$root.auxVars.loadResourcesOpts({
								vm: this,
								resourceNames: ["salesChannelsOpts"],
								forceRefresh: true
							});
							close();
						})
						.catch(err => {
							this.$root.handleRequestError(err);
							close();
						});
				}
			});
		}
	},
	mounted() {}
};
</script>

<style></style>
